// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio-group .form-check {
  display: flex;
  align-items: center;
  gap: 6px;
}
.radio-group .form-check .form-check-input {
  float: none;
  margin: 0;
  border: 2px solid #636366;
  height: 20px;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.radio-group .form-check .form-check-input:checked {
  background-color: transparent;
  border-color: var(--store-addons-for-woocommerce-color);
}
.radio-group .form-check .form-check-input:checked::before {
  background-color: var(--store-addons-for-woocommerce-color);
}
.radio-group .form-check .form-check-input::before {
  width: 10px;
  height: 10px;
  content: "";
  background-color: transparent;
  padding: 0;
  margin: 0;
  line-height: 10px;
}
.radio-group .form-check .content {
  display: flex;
  align-items: center;
  gap: 6px;
}
.radio-group.radio-group-inline .form-check {
  display: inline-flex;
  vertical-align: middle;
  flex-direction: row-reverse;
  padding-left: 0;
  margin-right: 12px;
}
.radio-group.radio-group-inline .form-check .content {
  flex-direction: row-reverse;
}
.radio-group.radio-group-inline .form-check:last-child {
  margin-right: 0;
}
.radio-group.radio-group-block .form-check {
  width: 100%;
  justify-content: space-between;
}
.radio-group.radio-group-block .form-check .form-check-input {
  order: 2;
  margin: 0;
}
.radio-group.radio-group-block .form-check .content .form-check-label {
  order: 2;
}
.radio-group.radio-group-block .form-check .content .hint-tooltip {
  order: 1;
}
.radio-group.radio-group-block .form-check.with-hints {
  padding-left: 0;
}
.radio-group.has-media {
  grid-gap: 10px;
}
.radio-group.has-media.radio-group-inline {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
.radio-group.has-media .form-check {
  margin-right: 0;
}
.radio-group.has-media .form-check .form-check-input {
  display: none;
}
.radio-group.has-media .form-check .form-check-input:checked ~ .content img {
  border-color: var(--store-addons-for-woocommerce-color);
}
.radio-group.has-media .form-check .content {
  display: flex;
  align-items: center;
  gap: 6px;
}
.radio-group.has-media .form-check .content img {
  max-width: 100%;
  height: auto;
  border: 10px solid #eaeaea;
}`, "",{"version":3,"sources":["webpack://./src/components/Radio/Radio.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAAJ;AAEI;EACE,WAAA;EACA,SAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAN;AACM;EACE,6BAAA;EACA,uDAAA;AACR;AAAQ;EACE,2DAAA;AAEV;AACM;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,6BAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;AACR;AAEI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAAN;AAII;EACE,oBAAA;EACA,sBAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;AAFN;AAGM;EACE,2BAAA;AADR;AAGM;EACE,eAAA;AADR;AAMI;EACE,WAAA;EACA,8BAAA;AAJN;AAKM;EACE,QAAA;EACA,SAAA;AAHR;AAMQ;EACE,QAAA;AAJV;AAMQ;EACE,QAAA;AAJV;AAOM;EACE,eAAA;AALR;AASE;EACE,cAAA;AAPJ;AAQI;EACE,aAAA;EACA,kCAAA;AANN;AAQI;EACE,eAAA;AANN;AAOM;EACE,aAAA;AALR;AAOU;EACE,uDAAA;AALZ;AASM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAPR;AAQQ;EACE,eAAA;EACA,YAAA;EACA,0BAAA;AANV","sourcesContent":[".radio-group {\n  .form-check {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n\n    .form-check-input {\n      float: none;\n      margin: 0;\n      border: 2px solid #636366;\n      height: 20px;\n      width: 20px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      &:checked {\n        background-color: transparent;\n        border-color: var(--store-addons-for-woocommerce-color);\n        &::before {\n          background-color: var(--store-addons-for-woocommerce-color);\n        }\n      }\n      &::before {\n        width: 10px;\n        height: 10px;\n        content: \"\";\n        background-color: transparent;\n        padding: 0;\n        margin: 0;\n        line-height: 10px;\n      }\n    }\n    .content {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n    }\n  }\n  &.radio-group-inline {\n    .form-check {\n      display: inline-flex;\n      vertical-align: middle;      \n      flex-direction: row-reverse;\n      padding-left: 0;\n      margin-right: 12px;\n      .content {        \n        flex-direction: row-reverse;\n      }\n      &:last-child{\n        margin-right: 0;\n      }\n    }\n  }\n  &.radio-group-block {\n    .form-check {\n      width: 100%;\n      justify-content: space-between;\n      .form-check-input {\n        order: 2;\n        margin: 0;\n      }\n      .content {\n        .form-check-label {\n          order: 2;\n        }\n        .hint-tooltip {\n          order: 1;\n        }\n      }\n      &.with-hints {\n        padding-left: 0;\n      }\n    }\n  }\n  &.has-media {\n    grid-gap: 10px;\n    &.radio-group-inline {\n      display: grid;\n      grid-template-columns: 1fr 1fr 1fr;\n    }\n    .form-check {\n      margin-right: 0;\n      .form-check-input {\n        display: none;\n        &:checked ~ .content {\n          img {\n            border-color: var(--store-addons-for-woocommerce-color);\n          }\n        }\n      }\n      .content {\n        display: flex;\n        align-items: center;\n        gap: 6px;\n        img {\n          max-width: 100%;\n          height: auto;\n          border: 10px solid #eaeaea;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
